module.exports = __webpack_public_path__ + "img/download2.f3e74f39.png";